// extracted by mini-css-extract-plugin
export default {"headerBar":"DevelopmentDialogues_headerBar__CUpUQ"};